import { create } from "zustand";
import { persist, createJSONStorage } from 'zustand/middleware'

const initialState = {
  id: "",
  idSize: "",
  idModel: "",
  idCategory: "",
  Name: "",
  Description: "",
  type: 0,
  Desing: null,
  returnToDiseñador: false, // Bandera para redirigir al diseñador después de login
  diseñadorParamsPendiente: null, // Parámetros del diseño cuando el usuario necesita login
}

export const useDesingStore = create(persist((set, get) => ({
  desingState: initialState,
  setDesing: (user) => set((state) => ({ desingState: user })),
  setDesingState: (partialState) => set((state) => ({
    desingState: { ...state.desingState, ...partialState },
  })),
  clearDesing: () => set((state) => ({ desingState: initialState })),
}), {
  name: 'desingStore',
  storage: createJSONStorage(() => localStorage),
}))